import axiosInstance from './intercept';

/* eslint-disable import/prefer-default-export */
export function fetchDisclosure(id) {
  return axiosInstance.get(`/v1/loan_disclosures/${id}?type=unsigned_headway_credit_limit_disclosure`);
}
